import React from 'react';
import { Table } from 'react-bootstrap';

const DescuentosTable = ({ descuentos, onDescuentoClick }) => {
	const [selected, setSelected] = React.useState(null);

	const handleDescuentoClick = (descuento) => {
		setSelected(descuento);
		onDescuentoClick(descuento);
	};

	return (
		<Table responsive="sm" striped bordered hover>
			<thead>
				<tr>
					<th>Nombre</th>
					<th>Descripción</th>
					<th>Tipo</th>
					<th>% Descuento</th>
					<th>Marca</th>
					<th>Tag</th>
					<th>Estado</th>
				</tr>
			</thead>
			<tbody>
				{descuentos?.map((descuento) => (
					<tr
						key={descuento._id}
						onClick={() => handleDescuentoClick(descuento)}
						className={selected?._id === descuento._id ? 'table-active' : ''}
					>
						<td>{descuento.nombre}</td>
						<td>{descuento.descripcion}</td>
						<td>{descuento.tipoDescuento}</td>
						<td>
							{descuento.tipoDescuento === 'porcentaje'
								? `${descuento.porcentajeDescuento}%`
								: '—'}
						</td>
						<td>{descuento.marca || '—'}</td>
						<td>{descuento.tagAplicable || '—'}</td>
						<td>{descuento.estado ? 'Activo' : 'Inactivo'}</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
};

export default DescuentosTable;
